<template>
  <div style="height: 100%">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">系统管理&nbsp;/&nbsp;</div>
        <div class="box-header-left-text">用户管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>详情</div>
        </div>
      </div>
    </div>
    <div class="section" style="padding: 0;padding-bottom: 20px;">
      <div class="box box-between p-15">
        <div class="box box-column-center">
          <img src="@/assets/image/company1.png" style="width: 72px;height: 72px;margin-right: 16px;">
          <div>
            <div class="topName">商户名称：{{ currentItem.pbmc }}</div>
            <div class="topThx">统一社会信用代码：{{ currentItem.tyshxydm }}</div>
          </div>
        </div>
        <div class="box">
          <el-button
            style="font-size: 16px"
            @click="cancel"
            size="mini"
            >
            <template class="box box-column-center">
              <!-- <img src="@/assets/image/back.png" style="width: 14px; height: 14px;margin-right: 5px;" /> -->
              <span>返回</span>
            </template>
            </el-button
          >
        </div>
      </div>
      <div class="line"></div>
      <div class="box box-column p-15">
        <div class="title mb-20">基本信息</div>
        <div class="info box box-column">
          <div class="box box-1">
            <div class="box-1 item tagBg">牌匾名称</div>
            <div class="box-3 item-bottom">{{ currentItem.pbmc }}</div>
            <div class="box-1 item tagBg">是否营业</div>
            <div class="box-3 item-bottom box box-wrap">
              <span>{{ currentItem.sfyy }}</span>
            </div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">负责人</div>
            <div class="box-3 item">{{ currentItem.zrr }}</div>
            <div class="box-1 item tagBg">联系电话</div>
            <div class="box-3 item">{{ currentItem.zrrsjh }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">所属片区</div>
            <div class="box-3 item">{{ currentItem.pian }}</div>
            <div class="box-1 item tagBg">所属社区</div>
            <div class="box-3 item">{{ currentItem.sq }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">社区负责人</div>
            <div class="box-3 item">{{ currentItem.sqfzr }}</div>
            <div class="box-1 item tagBg">社区负责人手机号</div>
            <div class="box-3 item">{{ currentItem.sqfzrsjh }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">执法队负责人</div>
            <div class="box-3 item">{{ currentItem.zfdfzr }}</div>
            <div class="box-1 item tagBg">执法队负责人手机号</div>
            <div class="box-3 item">{{ currentItem.zfdfzrsjh }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">所属联盟</div>
            <div class="box-3 item">{{ currentItem.zu }}</div>
            <div class="box-1 item tagBg">所属道路</div>
            <div class="box-3 item">{{ currentItem.dlmc }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">责任主体名称</div>
            <div class="box-3 item">{{ currentItem.zrztmc }}</div>
            <div class="box-1 item tagBg">责任主体地址</div>
            <div class="box-3 item">{{ currentItem.zrztdz }}</div>
          </div>
          <div class="box box-1">
            <div class="box-1 item tagBg">打卡时段</div>
            <div class="box-3 item">{{ currentItem.extendTimeRange }}</div>
            <div class="box-1 item tagBg">用户数</div>
            <div class="box-3 item">{{ currentItem.relHasAccountCount }}</div>
          </div>
          <div class="box box-1" v-if="currentItem.ckImgLeftJson">
            <div class="box-1 item tagBg">门店左侧照片</div>
            <div class="box-3 item box box-wrap">
              <el-image v-for="(item, index) in currentItem.ckImgLeftJson && JSON.parse(currentItem.ckImgLeftJson)" :key="index" :src="item.url" class="image" :preview-src-list="[item.url]"></el-image>
            </div>
            <div class="box-1 item tagBg">门店中间照片</div>
            <div class="box-3 item-right">
              <div class="box box-wrap" v-if="currentItem.ckImgCentreJson">
                <el-image v-for="(item, index) in currentItem.ckImgCentreJson && JSON.parse(currentItem.ckImgCentreJson)" :key="index" :src="item.url" class="image" :preview-src-list="[item.url]"></el-image>
              </div>
            </div>
          </div>
          <!-- <div class="box box-1" v-if="currentItem.ckImgCentreJson">
            <div class="box-1 item tagBg">门店中间照片</div>
            <div class="box-3 item-bottom box box-wrap">
              <el-image v-for="(item, index) in currentItem.ckImgCentreJson && JSON.parse(currentItem.ckImgCentreJson)" :key="index" :src="item.url" class="image" :preview-src-list="[item.url]"></el-image>
            </div>
            <div class="box-1 item-bottom"></div>
            <div class="box-3 item-right"></div>
          </div> -->
          <div class="box box-1" v-if="currentItem.ckImgRightJson">
            <div class="box-1 item tagBg">门店右侧照片</div>
            <div class="box-3 item-bottom box box-wrap">
              <el-image v-for="(item, index) in currentItem.ckImgRightJson && JSON.parse(currentItem.ckImgRightJson)" :key="index" :src="item.url" class="image" :preview-src-list="[item.url]"></el-image>
            </div>
            <div class="box-1 item-bottom"></div>
            <div class="box-3 item-right"></div>
          </div>
        </div>
        <div class="title mt-20 mb-20">所在地址</div>
        <div class="map-content mb-20">
          <MapCom :pointInfo="detailHandleList"></MapCom>
        </div>
        <div class="box box-column-center">
          <i class="el-icon-location-outline mr-10"></i>
          <span>{{ currentItem.zrztdz }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MapCom from "./map.vue";
export default {
  props: {
    dialogType: {
      type: String,
      default: ''
    },
    currentItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    MapCom
  },
  data () {
    return {
      // 审核结果：通过、不通过
      radio: '',
      // 审核意见
      applyContent: '',
      detailHandleList: {
        reportAddressLong: '117.20391594886048',
        reportAddressLat: '39.116957599893084'
      },
      dialogTableVisible: false
    }
  },
  mounted () {
    this.detailHandleList = {
      reportAddressLong: this.currentItem.longitude || 0,
      reportAddressLat: this.currentItem.latitude || 0
    }
  },
  methods: {
    // 取消
    cancel () {
      this.$emit('closeDialog');
    },
  }
} 
</script>

<style lang="less" scoped>
@import "~@/components/less.less";
* {
  font-size: 16px;
}
.cl-primary {
  color: #008CFF;
}
.topName {
  font-family: MiSans;
  font-size: 24px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0px;
  color: #494C4F;
}
.topThx {
  font-family: MiSans;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #0054FE;
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-2 {
  flex: 2;
}
.box-3 {
  flex: 3;
}
.box-7 {
  flex: 7;
}
.box-wrap {
  flex-wrap: wrap;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #E5EAF1;
}
.line {
  width: 100%;
  height: 16px;
  background: #f5f6f7;
}

.info {
  border-top: 1px solid #DFE5E8;
  border-left: 1px solid #DFE5E8;
  .item {
    padding: 14px 12px;
    border-right: 1px solid #DFE5E8;
    border-bottom: 1px solid #DFE5E8;
  }
  .item-right {
    padding: 14px 12px;
    border-right: 1px solid #DFE5E8;
    border-bottom: 1px solid #DFE5E8;
  }
  .item-bottom {
    padding: 14px 12px;
    border-bottom: 1px solid #DFE5E8;
  }
  .item-none {
    padding: 14px 12px;
  }
  .tagBg {
    background: #F1F4F6;
  }
  .image {
    width: 44px;
    height: 44px;
    border-radius: 4px;
    margin-right: 10px;
    margin-left: 10px !important;
    padding: 0 !important;
  }
}
.p-15 {
  padding: 15px;
}
.pb-10 {
  padding-bottom: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.bold {
  font-weight: bold;
}
.w100 {
  width: 130px;
}
.mb-10 {
  margin-bottom: 10px;
}
.pointer {
  cursor: pointer;
}
.mt-16 {
  margin-top: 16px;
}

.title {
  height: 17px;
  font-family: MiSans;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 18px;
  color: #494C4F;
  padding-left: 10px;
  position: relative;
  &::before {
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 4px;
    height: 17px;
    background: #0054FE;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/shtzDetail.vue